import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {FileUploadComponent} from "./file-upload.component";
import {FileUploadModule as CoreFileUploadModule} from "ng2-file-upload";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CoreFileUploadModule,
    ],
    declarations: [
        FileUploadComponent,
    ],
    exports: [
        FileUploadComponent
    ],
})
export class FileUploadModule {}